import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  CARE_PLAN_CASE_STATUS_LABEL,
  CarePlanCaseStatus,
} from '../../care-plan.model';

@Component({
  selector: 'bn-case-status-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="bn-case-status-badge" [attr.data-status]="status()">{{ label() }}</span>`,
  styleUrl: './case-status-badge.component.scss',
})
export class CaseStatusBadgeComponent {
  readonly status = input.required<CarePlanCaseStatus>();
  readonly displayLabel = input<string>();

  label(): string {
    return (
      this.displayLabel() ??
      CARE_PLAN_CASE_STATUS_LABEL[this.status()] ??
      this.status()
    );
  }

}
